<template>
  <div class="form-step-container">
    <div class="step-badge">
      {{ words.step }} {{ step }}
    </div>

    <!-- <h1 class="main-title" v-html="words.shipment"></h1> -->
    <h2 class="section-title" v-html="words.choose_number"></h2>
    <h3 class="subtitle" v-html="words.first_step_sec_title"></h3>

    <div id="numbers_wrapper" class="card-box">
      <div
        class="number_wrapper"
        :class="{ alert: activeItem && activeItem.alert }"
        @click="clearAlert"
      >
        <div class="card-top-bar">
          <div class="pack_num" v-html="'חבילה #' + activeIndex"></div>
          <div
            v-if="numbersInfo && numbersInfo.length > 1"
            class="trash-btn"
            @click.stop="onRemoveNumber(activeItem)"
          ></div>
        </div>

        <!-- טאבים לבחירה בין ניוד למספר חדש -->
        <div class="options round-tabs">
          <button
            type="button"
            class="tab-btn"
            :class="{ active: isHasNumberActive }"
            @click="onChangeHasNum(true)"
            v-html="words.has_number"
          ></button>

          <button
            type="button"
            class="tab-btn"
            :class="{ active: isDontHasNumberActive }"
            @click="onChangeHasNum(false)"
            v-html="words.dont_has_number"
          ></button>
        </div>

        <!-- טופס ניוד מספר קיים -->
        <div v-if="activeItem && activeItem.has_number" class="input-form">
          <div class="form-item modern-input">
            <label
              for="phone_number"
              class="input-label"
              v-html="words.port_number"
            ></label>
            <input
              id="phone_number"
              v-model="activeItem.phone_number"
              type="tel"
              inputmode="numeric"
              maxlength="13"
              placeholder="05X-XXXXXXX"
              class="field-input"
              autocomplete="off"
              @keypress="isNumber($event)"
            />
          </div>
        </div>

        <!-- טופס בחירת מספר חדש -->
        <div v-else class="number-grid-form">
          <template v-if="numbers && numbers.length > 0">
            <div class="options numbers-grid">
              <button
                v-for="(number, i) in numbers"
                :key="i"
                type="button"
                class="number-pill"
                :class="{ active: isSelectedNumber(number) }"
                @click="onSelectNewNumber(number)"
              >
                {{ number.number }}
              </button>
            </div>

            <button
              type="button"
              class="chose_number shuffle-btn"
              @click="getNumbers"
              v-html="words.mix_numbers"
            ></button>
          </template>
        </div>
      </div>
    </div>

    <div class="note">{{ words.us_note }}</div>

    <!-- כפתורים ופגינציה בתחתית -->
    <div class="btn_wrapper action-footer">
      <div class="paging">
        <button
          v-for="(item, i) in numbersInfo"
          :key="i"
          type="button"
          class="item_page"
          :class="{ active: activeItem && item.id === activeItem.id }"
          @click="setActiveNumberById(item.id)"
        >
          {{ i + 1 }}
        </button>
      </div>

      <div class="actions-group">
        <button
          v-if="numbersInfo && numbersInfo.length < 5"
          type="button"
          class="btn btn-secondary"
          @click="onAddNewNumber"
          v-html="words.add_new_number"
        ></button>

        <button
          type="button"
          class="btn btn-primary"
          @click="numbersValidation(true)"
          v-html="words.procced"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    numbersInfo: {
      type: Array,
      required: true,
      default: () => []
    },
    activeNumber: {
      type: [Number, String],
      required: true,
      default: 0
    },
    step: {
      type: Number,
      required: true,
      default: 1
    },
    numbers: {
      type: Array,
      required: true,
      default: () => []
    },
    numbers_overseas_info: {
      type: Array,
      default: () => []
    },
    numbersUs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    words() {
      return this.$store?.state?.words || {}
    },
    activeItem() {
      if (!this.numbersInfo || this.numbersInfo.length === 0) return {}
      return (
        this.numbersInfo.find((n) => n.id == this.activeNumber) ||
        this.numbersInfo[0] ||
        {}
      )
    },
    activeIndex() {
      if (!this.numbersInfo) return 1
      const index = this.numbersInfo.findIndex((n) => n.id == this.activeNumber)
      return index !== -1 ? index + 1 : 1
    },
    isHasNumberActive() {
      return (
        this.activeItem &&
        (this.activeItem.has_number === '1' || this.activeItem.has_number === true)
      )
    },
    isDontHasNumberActive() {
      return (
        this.activeItem &&
        (this.activeItem.has_number === 0 || this.activeItem.has_number === false)
      )
    }
  },
  methods: {
    clearAlert() {
      if (this.activeItem && this.activeItem.alert) {
        this.activeItem.alert = false
      }
    },
    isSelectedNumber(number) {
      return (
        this.activeItem && number && number.number === this.activeItem.phone_number
      )
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault()
      }
    },
    onSelectNewNumber(number) {
      if (this.activeItem) {
        this.activeItem.phone_number = number.number
      }
      this.numbersValidation(false)
    },
    setActiveNumberById(id) {
      this.$emit('setActiveNumber', id)
    },
    numbersValidation(next = false) {
      this.$emit('numbersValidation', next)
    },
    onRemoveNumber(num) {
      if (!num) return
      this.$emit('removeNumber', num)
    },
    onChangeHasNum(status) {
      if (!this.activeItem) return
      this.activeItem.has_number = status
      this.activeItem.phone_number = ''
      if (typeof this.api === 'function') {
        this.api({
          action: 'cart/change_has_num',
          data: { id: this.activeItem.id, status }
        })
      }
    },
    getNumbers() {
      this.$emit('getNumbers')
    },
    onAddNewNumber() {
      this.$emit('addNewNumber')
    }
  }
}
</script>

<style scoped lang="scss">
$purple-primary: #6B11D8;
$purple-light: #F5EFFF;
$purple-hover: #550bb1;
$bg-light: #F8F9FD;
$text-dark: #2B2635;
$text-muted: #718096;
$border-color: #E2E8F0;
$radius: 16px;

.form-step-container {
  direction: rtl;
  text-align: right;
  font-family: inherit;

  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

  .step-badge {
    display: inline-block;
    background: $purple-light;
    color: $purple-primary;
    font-size: 13px;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: 20px;
    margin-bottom: 8px;
  }

  .main-title {
    font-size: 22px;
    font-weight: 800;
    color: $text-dark;
    margin: 0 0 4px 0;
  }

  .section-title {
    font-size: 16px;
    font-weight: 700;
    color: $purple-primary;
    margin: 0 0 4px 0;
  }

  .subtitle {
    font-size: 13px;
    color: $text-muted;
    margin: 0 0 12px 0;
    font-weight: 400;
  }

  .card-box {
    background: #ffffff;
    border: 1px solid $border-color;
    border-radius: $radius;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);

    .card-top-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      .pack_num {
        font-size: 13px;
        font-weight: 700;
        background: $purple-light;
        color: $purple-primary;
        padding: 4px 12px;
        border-radius: 20px;
      }

      .trash-btn {
        color: #e53e3e;
        cursor: pointer;
        padding: 6px;
        transition: opacity 0.2s;

        &:hover {
          opacity: 0.7;
        }
      }
    }

    .round-tabs {
      display: flex;
      gap: 8px;
      background: $bg-light;
      padding: 4px;
      border-radius: 30px;
      margin-bottom: 14px;

      .tab-btn {
        flex: 1;
        border: none;
        outline: none;
        background: transparent;
        text-align: center;
        padding: 8px 14px;
        border-radius: 24px;
        font-size: 13px;
        font-weight: 600;
        color: $text-muted;
        cursor: pointer;
        transition: all 0.2s ease;

        &.active {
          background: #ffffff;
          color: $purple-primary;
          box-shadow: 0 2px 8px rgba(107, 17, 216, 0.12);
        }

        &:hover:not(.active) {
          color: $text-dark;
        }
      }
    }

    .modern-input {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-top: 8px;

      .input-label {
        font-size: 13px;
        font-weight: 600;
        color: $text-dark;
      }

      .field-input {
        width: 100%;
        padding: 10px 14px;
        border: 1.5px solid $border-color;
        border-radius: 12px;
        font-size: 15px;
        outline: none;
        transition: all 0.2s ease;
        background: #ffffff;
        color: $text-dark;
        box-sizing: border-box;

        &::placeholder {
          color: #a0aec0;
        }

        &:focus {
          border-color: $purple-primary;
          box-shadow: 0 0 0 3px rgba(107, 17, 216, 0.1);
        }
      }
    }

    .numbers-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
      gap: 8px;
      margin-bottom: 8px;
      max-height: 180px;
      overflow-y: auto;

      .number-pill {
        border: 1px solid $border-color;
        background: #ffffff;
        text-align: center;
        padding: 8px;
        border-radius: 10px;
        cursor: pointer;
        font-weight: 600;
        color: $text-dark;
        font-size: 14px;
        transition: all 0.2s ease;

        &:hover {
          border-color: $purple-primary;
          background: $purple-light;
        }

        &.active {
          border-color: $purple-primary;
          background: $purple-primary;
          color: #ffffff;
        }
      }
    }

    .shuffle-btn {
      background: none;
      border: none;
      padding: 0;
      font-size: 13px;
      font-weight: 600;
      color: $purple-primary;
      cursor: pointer;
      margin-top: 4px;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .note {
    font-size: 12px;
    color: $text-muted;
    margin-bottom: 12px;
    line-height: 1.4;
  }

  .action-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-top: auto;
    flex-wrap: wrap;

    .paging {
      display: flex;
      gap: 6px;

      .item_page {
        border: none;
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: $bg-light;
        color: $text-muted;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.2s ease;

        &.active {
          background: $purple-primary;
          color: #ffffff;
        }

        &:hover:not(.active) {
          background: $border-color;
        }
      }
    }

    .actions-group {
      display: flex;
      gap: 8px;

      .btn {
        border: none;
        padding: 10px 18px;
        border-radius: 30px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s ease;

        &.btn-primary {
          background: $purple-primary;
          color: #ffffff;

          &:hover {
            background: $purple-hover;
            box-shadow: 0 4px 12px rgba(107, 17, 216, 0.25);
          }
        }

        &.btn-secondary {
          background: transparent;
          border: 1.5px dashed $purple-primary;
          color: $purple-primary;

          &:hover {
            background: $purple-light;
          }
        }
      }
    }
  }
}
</style>